export enum FlightFilterCategories {
  Price = 'price',
  Stops = 'stops',
  Duration = 'duration',
  PaymentMethod = 'paymentMethod',
  BookingSites = 'bookingSites',
  BookingOptions = 'bookingOptions',
  Airlines = 'airlines',
  Alliances = 'alliances',
  Times = 'times',
  OriginAndDestination = 'originAndDestination',
  Transit = 'transit',
  Experience = 'experience',
}
